import store from '@/store/store';
import { notificationsMixin } from './notifications';

/**
 *  Mixin do zarządzania dialogiem usunięcia konta
 *  Zawiera pola
 *  - `profiledeleteDialog` - czy pokazać modal dodawania / edycji
 *  - `profiledeleteText` - tekst do wyświetlenia w dialogu
 *  - `profileId` - Id profilu do usunięcia
 *  Zawiera metody
 *  - `showDeleteDialog()` - Otwiera okienko usunięcia konta
 *  - `hideDeleteDialog()` - Ukrywa okienko usunięcia konta
 *  - `deleteProfile()` - Usuwa konto
 */
export const deleteProfileMixin = {
  mixins: [notificationsMixin],
  /**
   * Dane modułu
   *
   * @returns
   */
  data() {
    return {
      profiledeleteDialog: false,
      profiledeleteText: '',
      profileId: undefined
    };
  },
  methods: {
    /**
     * Otwiera okienko usunięcia konta
     */
    showDeleteDialog() {
      this.passwordText = 'Czy na pewno chcesz usunąć konto?';
      this.profileId = this.profile.id;
      this.profiledeleteDialog = true;
    },
    /**
     * Ukrywa okienko usunięcia konta
     */
    hideDeleteDialog() {
      this.profiledeleteDialog = false;
    },
    /**
     * Usuwa konto
     */
    deleteProfile() {
      if (this.profileId) {
        store
          .dispatch('profiles/remove', this.profileId)
          .then(() => {
            this.notifySuccess('Konto zostało usunięte');
            this.$router.push({ name: 'clientList' });
          })
          .catch(err => this.notifyError('Nie udało usunąć konta.', [err.graphQLErrors[0].message]));
      } else {
        this.notifyError('Nie pobrano id profilu');
      }
    }
  }
};
